
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { Part } from "@/data/parts";
// import { fetchAllParts } from "@/services/partService"; // Temporarily commented out
import { parts as staticParts } from "@/data/parts";

/**
 * Hook for fetching and managing parts data from Supabase or static data
 * Currently using static data only (Supabase disabled)
 */
export const usePartsData = (isSupabaseConnected: boolean | null) => {
  // Commented out Supabase query for now
  /* 
  const { data: supabaseParts, isLoading, isError } = useQuery({
    queryKey: ['parts'],
    queryFn: fetchAllParts,
    enabled: isSupabaseConnected === true,
    meta: {
      onError: (error: Error) => {
        console.error("Error fetching parts:", error);
      }
    }
  });
  */
  
  // Mock the query response with static data
  const isLoading = false;
  const isError = false;
  
  // Always use static parts data
  const allParts = useMemo(() => {
    return staticParts;
  }, []);

  return {
    allParts,
    isLoading,
    isError,
  };
};
